<template>
  <v-badge
    class="open-windows-badge"
    color="red darken-2"
    :content="getActiveWindowsCount"
    :value="getActiveWindowsCount > 0"
    :offset-x="offsetX"
    :offset-y="offsetY"
    overlap
  >
    <slot
      name="content"
      :icon="icon"
    >
      <w-icon size='24'>
        $wHistory
      </w-icon>
    </slot>
  </v-badge>
</template>

<script>
import activeWindowService from '@/store/services/active-window-service';
import { mapGetters } from 'vuex';

export default {
  name: "WorkHeaderOpenWindowsBadge",
  computed: {
    ...mapGetters('badgeCounter', ['getActiveWindowsCount']),
  },
  props: {
    offsetX: { type: String, default: "10" },
    offsetY: { type: String, default: "10" },
  },
  data() {
    return {
      icon: 'history'
    }
  },
  mounted() {
    activeWindowService.updateActiveWindowCount();
  },
}
</script>

<style lang="scss">
.open-windows-badge .v-badge__badge {
  font-size: 0.6875rem !important;
  height: 0.875rem !important;
  min-width: 0.875rem !important;
  line-height: 1.4 !important;
  padding: 0;
}
</style>
